import React from 'react';

import LoadSpinner from './loadSpinner.svg';

import type { SVGProps } from 'react';

export type Props = {
  color?: string;
  size?: number | string;
} & SVGProps<SVGSVGElement>;

const getDisplayName = (WrappedComponent: any) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component';

function withIconProps(
  WrappedComponent: any,
  options: {
    shouldSetDefaultSize?: boolean;
    defaultWidth?: number;
    defaultHeight?: number;
  } = {
    shouldSetDefaultSize: true,
    defaultWidth: 24,
    defaultHeight: 24,
  },
) {
  function NewComponent(props: Props) {
    const { size, color, className, ...rest } = props;

    const style = {
      height: props.size,
      width: props.size,
      ...(color && { color }),
    };

    if (options.shouldSetDefaultSize) {
      style.height = style.height || options.defaultHeight;
      style.width = style.width || options.defaultWidth;
    }

    return <WrappedComponent {...rest} className={className} style={style} />;
  }

  NewComponent.displayName = `withIconProps(${getDisplayName(WrappedComponent)})`;

  NewComponent.defaultProps = {
    color: 'default',
  };

  return NewComponent;
}

export default withIconProps(LoadSpinner);
